import React, { PropTypes } from 'react';
import moment from 'moment';
import truncate from 'lodash/truncate';
import { v4 } from 'node-uuid';
import { Link } from 'react-router';
import ReputationChart from 'common/components/reputation_chart';
import ReputationTag from 'common/components/reputation_tag';
import AccessTypeAction from 'project/containers/access_type_action';
import Avatar from 'common/components/avatar';
import { ADMIN_ROOT } from 'common/variables';

const EmptyResults = ({ type }) => (
  <div className="small-16 column">
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <h3>No {type} creatives</h3>
        { type !== 'denied' &&
        <div className="empty-state-cta">
          <Link className="btn btn-primary btn-md" to="/explore/creatives/">Invite</Link>
        </div> }
      </div>
    </div>
  </div>
);

EmptyResults.propTypes = {
  type: PropTypes.string.isRequired,
};

const AccessTableRow = ({ id, user, updated_at, request_accepted, contract, isAdmin }) => {
  const reputationInt = parseInt(user.reputation, 10);
  const creativeUrl = isAdmin? `${ADMIN_ROOT}/creative/${user.id}/` : `/users/${user.username}/`;

  return (<tr>
    <td>
      <Link to={creativeUrl} target="_blank">
        <Avatar user={user} extraClasses="avatar-sm avatar-inline show-for-medium" />
        {' '}
        <span className="hide-for-small-only">{ user.username }</span>
        <span className="show-for-small-only">{ truncate(user.username, { length: 15 }) }</span>
      </Link>
    </td>
    <td>
      <ReputationChart containerClass="stat-chart" reputation={reputationInt} chartClass="small" />
      <ReputationTag user={user} extraClasses="hide-for-small-only" />
    </td>
    <td>{moment(updated_at).fromNow()}</td>
    <td className="show-for-medium">
      <a href={contract.pdf} target="_blank"><i className="fa fa-file-pdf-o" /></a>
    </td>
    <td><AccessTypeAction ndaId={id} requestAccepted={request_accepted} /></td>
  </tr>);
};

AccessTableRow.propTypes = {
  id: PropTypes.number,
  user: PropTypes.object,
  updated_at: PropTypes.string,
  request_accepted: PropTypes.bool,
  contract: PropTypes.object,
  isAdmin: PropTypes.bool,
};

const AccessTable = ({ ndas, type, isAdmin }) => {
  if (!ndas.length) {
    return (<EmptyResults type={type} />);
  }

  return (<div className="small-16 column">
    <table className="table table-default access">
      <thead>
        <tr>
          <td>User</td>
          <td>Reputation</td>
          <td>Date</td>
          <td className="show-for-medium">NDA</td>
          <td />
        </tr>
      </thead>
      <tbody>
        { ndas.map(nda => (
          <AccessTableRow key={v4()} isAdmin={isAdmin} {...nda} />
        )) }
      </tbody>
    </table>
  </div>);
};

AccessTable.propTypes = {
  ndas: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool,
};

export default AccessTable;



// WEBPACK FOOTER //
// ./project/components/access_table.jsx